exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".list-group{\r\n    margin: 0px;\r\n    height: auto;\r\n    cursor: pointer;\r\n}\r\n\r\n.list-group-item{\r\n    display: flex;\r\n    flex-direction: row;\r\n    background-color: transparent;\r\n    padding: 8px 10px;\r\n    border: 0px;\r\n    text-align: left;\r\n    border-radius: 8px;\r\n    transition: background-color 0.15s ease, box-shadow 0.15s ease;\r\n}\r\n\r\n.list-group-item.sidebar-item:hover{\r\n    background-color: rgba(255, 255, 255, 0.10);\r\n    box-shadow: 0 2px 8px rgba(0,0,0,0.22);\r\n}\r\n\r\n\r\n\r\n.item-titulo{\r\n    color: white;\r\n    display: block;\r\n    width: 100%;\r\n}\r\n\r\n.list-group-item.sidebar-item:hover .item-titulo{\r\n    color: rgba(255, 255, 255, 0.92);\r\n}\r\n\r\n.item-icono{\r\n    color: rgb(255, 255, 255);\r\n    padding-right: 10px;\r\n}\r\n\r\na .list-group-item{\r\n    border-radius: 0px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/portal/components/sidebar/components/preferidos/item-preferidos/item-preferido.style.css
// module id = 641
// module chunks = 0